var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from 'react';
import { PanelContext } from '../../context';
import { ELEMENT_TYPES } from '../../helpers/ElementTypes';
import { PanelFooterContainer } from './styles';
/**
 * The panelfooter is an optional bottom footer for a panel
 */
const PanelFooter = (_a) => {
    var { children, class: className, withBorderRadius = false, withBackground = false } = _a, props = __rest(_a, ["children", "class", "withBorderRadius", "withBackground"]);
    const { dataTest } = useContext(PanelContext);
    if (!children)
        return null;
    return (_jsx(PanelFooterContainer, Object.assign({ className: className, "$withBorderRadius": withBorderRadius, "$withBackground": withBackground, "data-test": `${dataTest}-footer` }, props, { children: children })));
};
PanelFooter.PANEL_ELEMENT = ELEMENT_TYPES.FOOTER;
export { PanelFooter };
